import { logOut } from "../../libs/auth";
import { UserDeleteResponse } from "../../proto/UserDelete_pb";
import BaseHandler from "../BaseHandler";

export default class HandleUserDeleteResponse extends BaseHandler<UserDeleteResponse> {
  handle() {
    logOut().then();
  }
}
